import React, { useState } from "react";
import { Form, Input, Spin } from "antd";
import "./styles.scss";
import { httpService } from "../../../services/httpService.service";
import MessagePopUp from "../../components/Messages/MessagePopUp";
import Done from "../../../Assets/svg/done.svg";
import ExclamationMark from "../../../Assets/svg/exclamationMark.svg";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";

const SignUp = () => {
  const [form] = Form.useForm();
  const [loadingPage, setLoadingPage] = useState(false);
  const navigate = useNavigate();
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });

  const handleSubmit = (values) => {
    setLoadingPage(true);

    httpService.post(
      "/api/ContactUs/contactUs",
      values,
      (response) => {
        setMessage({
          trigger: true,
          type: "success",
          icon: Done,
          title: "Message sent!",
          text: response?.message || "Your message has been sent successfully.",
        });

        form.resetFields();
        setLoadingPage(false);

        setTimeout(() => {
          setMessage({ trigger: false });
        }, 3000);
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      },
      (error) => {
        setMessage({
          trigger: true,
          type: "danger",
          icon: ExclamationMark,
          title: "Oops! Something went wrong",
          text:
            error?.errors?.[0]?.message ||
            error?.message ||
            "Failed to send your message. Please try again.",
        });

        setLoadingPage(false);

        setTimeout(() => {
          setMessage({ trigger: false });
        }, 3000);
      }
    );
  };

  return (
    <div className="wrapper">
      <div className="row">
        <div className="col-md-6 left-column">
          <img
            src="/assets/svg/LoginImage.svg"
            alt="Contact Us"
            className="leftImage"
          />
        </div>

        <MessagePopUp
          trigger={message.trigger}
          type={message.type}
          icon={message.icon}
          messageTitle={message.title}
          messageText={message.text}
        />

        <div className="col-md-6 right-column">
          <div className="form-wrapper">
            <h2>Sign Up</h2>

            <Form form={form} layout="vertical" onFinish={handleSubmit}>
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Name is required" }]}
              >
                <Input placeholder="Enter your full name" />
              </Form.Item>

              <Form.Item
                label="Company"
                name="company"
                rules={[{ required: true, message: "Company is required" }]}
              >
                <Input placeholder="Your company name" />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Enter a valid email",
                  },
                ]}
              >
                <Input placeholder="Enter your email address" />
              </Form.Item>

              <Form.Item label="Phone Number" name="phoneNumber">
                <Input placeholder="Enter your phone number" />
              </Form.Item>

              <Form.Item
                label="Message"
                name="message"
                rules={[{ required: true, message: "Message is required" }]}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Write your message here..."
                />
              </Form.Item>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={loadingPage}
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {loadingPage && (
                  <Spin
                  style={{color:"white",}}
                    indicator={<LoadingOutlined style={{ fontSize: 22, color: "white" }} spin />}
                  />
                )}
                Send Message
              </button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
